import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link, useLocation, useNavigate } from "react-router-dom";
import Portfolio from "./components/Portfolio";
import FiveOhSevenPortfolio from "./pages/FiveOhSevenPortfolio";

function GlobalNav({ activePage, setActivePage }) {
    const location = useLocation();
    const navigate = useNavigate();
    const is507 = location.pathname.startsWith("/507-mechanical-movements") || location.pathname.startsWith("/507-mechanical-movements");
    const isMobile = window.innerWidth < 640;
    const [menuOpen, setMenuOpen] = useState(false);

    // Active when on 507 index or any movement deep-link
    const isModelsActive = location.pathname === "/507-mechanical-movements" || location.pathname.startsWith("/507-mechanical-movements/movement-");

    const topLeftStyle = {
        position: "fixed", top: "1.6rem", left: "2rem",
        margin: 0, zIndex: 1000,
        fontFamily: "'Bitcount Grid Single', monospace",
        fontWeight: 350, fontSize: "3.5rem",
        color: "rgba(255,255,255,0.88)", lineHeight: 1,
        textDecoration: "none", cursor: "pointer"
    };

    const navStyle = {
        position: "fixed", top: "2.7rem",
        right: "22rem",
        display: "flex", gap: "60px",
        zIndex: 1000, pointerEvents: "all",
    };

    const linkStyle = (active = false) => ({
        background: "none", border: "none",
        color: active ? "rgba(255,255,255,0.9)" : "rgba(255,255,255,0.35)",
        fontSize: "15px", letterSpacing: "0.2em", textTransform: "uppercase",
        cursor: "pointer", textDecoration: "none", transition: "color 0.2s",
        fontFamily: "'DM Sans', sans-serif",
    });

    const handleWorkModelsClick = () => {
        if (is507) {
            navigate("/507-mechanical-movements");
        } else {
            setActivePage("Work");
        }
        setMenuOpen(false);
    };

    const menuLinks = [
        {
            label: is507 ? "Models" : "Work",
            active: is507 ? isModelsActive : activePage === "Work",
            onClick: handleWorkModelsClick,
        },
        {
            label: "About",
            active: is507 ? location.pathname.includes("/about") : activePage === "About",
            onClick: () => {
                if (is507) navigate("/507-mechanical-movements/about");
                else setActivePage("About");
                setMenuOpen(false);
            },
        },
        {
            label: "Contact",
            active: is507 ? location.pathname.includes("/contact") : activePage === "Contact",
            onClick: () => {
                if (is507) navigate("/507-mechanical-movements/contact");
                else setActivePage("Contact");
                setMenuOpen(false);
            },
        },
        {
            label: is507 ? "Portfolio" : "507 Mechanical Movements",
            active: false,
            onClick: () => {
                if (is507) { navigate("/"); setActivePage("Work"); }
                else navigate("/507-mechanical-movements");
                setMenuOpen(false);
            },
        },
    ];

    return (
        <>
            {/* TOP LEFT */}
            <div style={topLeftStyle} onClick={() => { navigate("/"); setActivePage("Work"); }}>
                {!is507 ? (
                    <span>Ibrahim Tayyab</span>
                ) : (
                    <div>
                        <p style={{ margin: 5, fontSize: "2rem", letterSpacing: "0.1em" }}>507 Mechanical Movements</p>
                        <p style={{ margin: "10px 5px 0", fontSize: "23px", opacity: 0.4, letterSpacing: "0.2em" }}>HENRY T. BROWN</p>
                    </div>
                )}
            </div>

            {/* DESKTOP NAV */}
            {!isMobile && (
                <div style={navStyle}>
                    <button onClick={handleWorkModelsClick} style={linkStyle(is507 ? isModelsActive : activePage === "Work")}>
                        {is507 ? "Models" : "Work"}
                    </button>
                    <button onClick={() => { if (is507) navigate("/507-mechanical-movements/about"); else setActivePage("About"); }}
                        style={linkStyle(is507 ? location.pathname.includes("/about") : activePage === "About")}>
                        About
                    </button>
                    <button onClick={() => { if (is507) navigate("/507-mechanical-movements/contact"); else setActivePage("Contact"); }}
                        style={linkStyle(is507 ? location.pathname.includes("/contact") : activePage === "Contact")}>
                        Contact
                    </button>
                    {!is507 ? (
                        <Link to="/507-mechanical-movements" style={{ ...linkStyle() }}>507 Movements</Link>
                    ) : (
                        <Link to="/" onClick={() => setActivePage("Work")} style={{ ...linkStyle() }}>Portfolio</Link>
                    )}
                </div>
            )}

            {/* MOBILE HAMBURGER */}
            {isMobile && (
                <div style={{ position: "fixed", top: "1.8rem", right: "1.2rem", zIndex: 1000, pointerEvents: "all" }}>
                    <button
                        onClick={() => setMenuOpen(o => !o)}
                        style={{ background: "none", border: "none", cursor: "pointer", display: "flex", flexDirection: "column", gap: "5px", padding: "10px" }}
                    >
                        <div style={{ width: "27px", height: "2.5px", background: "rgba(255,255,255,0.6)" }} />
                        <div style={{ width: "27px", height: "2.5px", background: "rgba(255,255,255,0.6)" }} />
                        <div style={{ width: "27px", height: "2.5px", background: "rgba(255,255,255,0.6)" }} />
                    </button>
                    {menuOpen && (
                        <div style={{ position: "absolute", top: "100%", right: -10, minWidth: "160px", marginTop: "5px", display: "flex", flexDirection: "column" }}>
                            {menuLinks.map(item => (
                                <button key={item.label} onClick={item.onClick} style={{
                                    textAlign: "right", background: "none", border: "none",
                                    padding: "12px 20px",
                                    color: item.active ? "#fff" : "rgba(255,255,255,0.7)",
                                    fontSize: "13px", textTransform: "uppercase",
                                    letterSpacing: "0.15em", cursor: "pointer",
                                    fontFamily: "'DM Sans', sans-serif",
                                }}>{item.label}</button>
                            ))}
                        </div>
                    )}
                </div>
            )}
        </>
    );
}

function App() {
    const [activePage, setActivePage] = useState("Work");
    return (
        <Router>
            <GlobalNav activePage={activePage} setActivePage={setActivePage} />
            <Routes>
                <Route path="/507-mechanical-movements/*" element={<FiveOhSevenPortfolio />} />
                {/* Homepage and every /work/<model> URL share one viewer so switching models doesn't reload the page */}
                <Route path="/*" element={<Portfolio activePage={activePage} setActivePage={setActivePage} />} />
            </Routes>
        </Router>
    );
}
export default App;